import React,{Component} from 'react';
import './Card.css'

class Card1 extends Component{

    render(){
        return(
            <div class="box">
      <div class="carder">
        <div class="imgBx">
        <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/wsVrV7ox60Q" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
        <div class="details">
            <h2>Lecture 1<br /></h2>
        </div>
      </div>
    
       <div class="carder">
         <div class="imgBx">
         <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/8_Af5C0CI-M?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
         
         </div>
         <div class="details">
            <h2>Lecture 2</h2>
          </div>
       </div>

       <div class="carder">
         <div class="imgBx">
         <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/ef81EaGPs_0?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
         </div>
         <div class="details">
            <h2>Lecture 3<br /></h2>
          </div>
       </div>
 
  </div>
        )
    }
}

class Card2 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/v9hJJlwxmPM?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowfullscreen="true"></iframe>
      </div>
      <div class="details">
          <h2>Lecture 4<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/OMOfZ1-XYvw?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
       </div>
       <div class="details">
          <h2>Lecture 5</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/qLfoa97CKXM?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
       </div>
       <div class="details">
          <h2>Lecture 6<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card3 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/6iH07ArleTk?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
      <div class="details">
          <h2>Lecture 7<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/9yWxNwL8vg0?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
         </div>
       <div class="details">
          <h2>Lecture 8</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/NMyB0NR-lnM?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 9<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card4 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/AMWgN3XUpfI?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
      <div class="details">
          <h2>Lecture 10<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/w5xBhaJsKKE?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 11</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/aBclF3o9IAU?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 12<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card5 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/5u79gvwODEc?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>      
        </div>
      <div class="details">
          <h2>Lecture 13<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/UY8f6XHwbag" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 14</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/DZLQ1Fgcd6Q?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
       </div>
       <div class="details">
          <h2>Lecture 15<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card6 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/vfgjJ_A_OwU?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
      <div class="details">
          <h2>Lecture 16<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/7PEXog4E9RM?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 17</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/RpGXOC_JFss?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 18<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card7 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/y86WjaWa7Ag?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
       </div>
      <div class="details">
          <h2>Lecture 19<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/ydbENNkf8HQ?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
         </div>
       <div class="details">
          <h2>Lecture 20</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/rQp15mYV8Ss?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 21<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card8 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ETzFAomvwFQ?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
         </div>
      <div class="details">
          <h2>Lecture 22<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/gSIVh2A_kPc?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 23</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/IsSsaJbVDNQ?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 24<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card9 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/iEUq4dB2myU?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
      <div class="details">
          <h2>Lecture 25<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"  src="https://www.youtube.com/embed/3oGCZHpzpf0?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 26</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe  width="100%" height="100%" src="https://www.youtube.com/embed/ge1RsojoMR0?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 27<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card10 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/jy5UIUdR3mE?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
      <div class="details">
          <h2>Lecture 28<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"src="https://www.youtube.com/embed/IyExmH_kKIs?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 29</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/xolXjPWCIBY?list=PLNzsbZjYvXf86efy9gd8y9jJQ54ey6Eqa" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
        </div>
       <div class="details">
          <h2>Lecture 30<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card11 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Il7ZbQdghy4?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
      <div class="details">
          <h2>Lecture 31<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/77kS0J2AnRw?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 32</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/wKWjDjRJkws?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 33<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card12 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/aR8Y-Ik6aEE?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
      <div class="details">
          <h2>Lecture 34<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/BrSNKWH_pSY?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 35</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/UZkUtMePGtg?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
          </div>
       <div class="details">
          <h2>Lecture 36<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card13 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/JNKCRnopZ3U?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
      <div class="details">
          <h2>Lecture 37<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/aPs_Mrwl9qo?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 38</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/HnWisddD9dc?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
       </div>
       <div class="details">
          <h2>Lecture 39<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card14 extends Component{

  render(){
      return(
          <div class="box">
  
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ydAYOIf47yg?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 40</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/5zIDUJy118U?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 41<br /></h2>
        </div>
     </div>
     <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/6oGFtQBHzns" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
      <div class="details">
          <h2>Lecture 42<br /></h2>
      </div>
    </div>

</div>
      )
  }
}


class Card15 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/w_ZZot8wwdo?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
      <div class="details">
          <h2>Lecture 43<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/0oj-P_L4ayI?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 44</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/IfOjmFJLK_I?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 45<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card16 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe wwidth="100%" height="100%" src="https://www.youtube.com/embed/M6M_opl5Eig?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
      <div class="details">
          <h2>Lecture 46<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/bamDhcRVjX0?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 47</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ORWZFL4pFh8?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 48<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card17 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/pz7MRv_wZHU?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
      <div class="details">
          <h2>Lecture 49<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/E5s6IWpvxWc?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 50</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/TNE16XNDMjE?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 51<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card18 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/taSDqUak8Tw?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
             </div>
      <div class="details">
          <h2>Lecture 52<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/MU8EtmHzP6I?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 53</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/i27FgYn2MDw?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 54<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card19 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/3y54tw55GnU?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
      <div class="details">
          <h2>Lecture 55<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
          <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Gl55z5V7OwQ?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 56</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/CPgOmoutoio?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 57<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card20 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/M_Hm0hhxchM?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
      <div class="details">
          <h2>Lecture 58<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/_3WZQIyRvJo?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 59</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/JyTuvfQJV8I?list=PLNzsbZjYvXf-15Tg9RcMNNuzX0ZvxHZ_u" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 60<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card21 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/kXbioRB4GrU?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
      <div class="details">
          <h2>Lecture 61<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/MPMJ8b7extg?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 62</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/qVPFa9Sx-_4?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 63<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card22 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/_Y-MBQfZrdA?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
      <div class="details">
          <h2>Lecture 64<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/DDi3bqBwECE?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 65</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/nMVcvp1x1Do?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
           </div>
       <div class="details">
          <h2>Lecture 66<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card23 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/4LLvU0RpxlQ?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
             </div>
      <div class="details">
          <h2>Lecture 67<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/MCbP2O9GWDs?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 68</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/7iuFYWd_tdk?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 69<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card24 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%"src="https://www.youtube.com/embed/PKA5tnjGBwI?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
      <div class="details">
          <h2>Lecture 70<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/yzXKqWBPgvo?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 71</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ofiweSRolSc?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 72<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card25 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/gdpgpuhMng0?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
      <div class="details">
          <h2>Lecture 73<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/iADUZ6J3C2w?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 74</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/pJpphc06I24?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
            </div>
       <div class="details">
          <h2>Lecture 75<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card26 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/q6ymYXyk9qI?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 76<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/WZT3vwCXyx0?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 77</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/J9VmGNoctEE?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 78<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card27 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/rDudfypWl3A?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 79<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/RudnrijoG2E?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 80</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/KC5Cpteug3s?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
             </div>
       <div class="details">
          <h2>Lecture 81<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card28 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/OwuSM7hL8NI?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
               </div>
      <div class="details">
          <h2>Lecture 82<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/4i6fp0QXosI?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 83</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/8rWQhYZPnBA?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 84<br /></h2>
        </div>
     </div>

</div>
      )
  }
}
class Card29 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/TkF-fMi6oKs?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 85<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/SfIPRoAcNOA?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 86</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/tMO7uqZ2Mp4?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 87<br /></h2>
        </div>
     </div>

</div>
      )
  }
}
class Card30 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/m8Sbj6ZHTFM?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 88<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/sl-ePMm4zeo?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 89</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/2LJceEBiI10?list=PLNzsbZjYvXf9sR2WrFCzNajIc3QOXxb1T" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 90<br /></h2>
        </div>
     </div>

</div>
      )
  }
}
class Card31 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/WdaByZA9njg?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 91<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/C9aLgZC2m34?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
               </div>
       <div class="details">
          <h2>Lecture 92</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/pyg19e62PFI?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 93<br /></h2>
        </div>
     </div>

</div>
      )
  }
}
class Card32 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/C9gPb561Z_I?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 94<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/keDAiM6fm-Q?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 95</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/pc4l-w4MKNE?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
             </div>
       <div class="details">
          <h2>Lecture 96<br /></h2>
        </div>
     </div>

</div>
      )
  }
}
class Card33 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/K4Lf-h9wOVw?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 97<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/KaUlFId_1nk?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 98</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/cVkWFhNSdug?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 99<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card34 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Mhl9OY0YtRs?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 100<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/DYrhIiE6z0w?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 101</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%"src="https://www.youtube.com/embed/eLQ39yhIXcE?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 102<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card35 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/KZSkpe9brZg?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 103<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/JM1zs-Pul2E?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 104</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ge35N3SkP60?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 105<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card36 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/BlNYQDyIm6Y?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 106<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/HP_FM8WsDbQ?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
               </div>
       <div class="details">
          <h2>Lecture 107</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/er6Opa1VaVA?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 108<br /></h2>
        </div>
     </div>

</div>
      )
  }
}

class Card37 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/TKZwrbUc36g?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
      <div class="details">
          <h2>Lecture 109<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/QooxNCfRijs?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 110</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/3Lacxp2zrHo?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
             </div>
       <div class="details">
          <h2>Lecture 111<br /></h2>
        </div>
     </div>

</div>
      )
  }
}
class Card38 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/Vu_hnOJmtTs?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
               </div>
      <div class="details">
          <h2>Lecture 112<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/RUC9veYSHVM?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 113</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/CLadyqh6eD4?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
              </div>
       <div class="details">
          <h2>Lecture 114<br /></h2>
        </div>
     </div>

</div>
      )
  }
}
class Card39 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/bVYXFQ3m83E?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
      </div>
      <div class="details">
          <h2>Lecture 115<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/bVYXFQ3m83E?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
       </div>
       <div class="details">
          <h2>Lecture 116</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/GFAwjl-oFWE?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0"  allowfullscreen="true"></iframe>
       </div>
       <div class="details">
          <h2>Lecture 117<br /></h2>
        </div>
     </div>

</div>
      )
  }
}
class Card40 extends Component{

  render(){
      return(
          <div class="box">
    <div class="carder">
      <div class="imgBx">
      <iframe width="100%" height="100%" src="https://www.youtube.com/embed/ayfEmjqcHCA?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowfullscreen="true"></iframe>
      </div>
      <div class="details">
          <h2>Lecture 118<br /></h2>
      </div>
    </div>
  
     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/89nIKwNV1Wc?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
       </div>
       <div class="details">
          <h2>Lecture 119</h2>
        </div>
     </div>

     <div class="carder">
       <div class="imgBx">
       <iframe width="100%" height="100%" src="https://www.youtube.com/embed/hnMyKnukUZw?list=PLNzsbZjYvXf9D_PkodiOGE5slHZVOdVRO" title="lecture" frameborder="0" allowFullScreen="true"></iframe>
       </div>
       <div class="details">
          <h2>Lecture 120<br /></h2>
        </div>
     </div>

</div>
      )
  }
}




export {Card1,Card2,Card3,Card4,Card5,Card6,Card7,Card8,Card9,Card10,
  Card11,Card12,Card13,Card14,Card15,Card16,Card17,Card18,Card19,Card20,
  Card21,Card22,Card23,Card24,Card25,Card26,Card27,Card28,Card29,Card30,
Card31,Card32,Card33,Card34,Card35,Card36,Card37,Card38,Card39,Card40};